import { MediaItem } from '@property/shared';
import { Camera } from 'lucide-react';
import { MediaCard } from '@/components/media-card';
import { useState } from 'react';

interface SiteMediaSectionProps {
  mainAccessPoint: MediaItem[];
  siteOverview: MediaItem[];
  onMediaSelect: (item: MediaItem) => void;
}

export function SiteMediaSection({
  mainAccessPoint,
  siteOverview,
  onMediaSelect,
}: SiteMediaSectionProps) {
  const [failedMediaIds, setFailedMediaIds] = useState<Set<string>>(new Set());

  const handleImageError = (id: string) => {
    setFailedMediaIds((prev) => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });
  };

  const displayItems = [...mainAccessPoint, ...siteOverview];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between px-1">
        <h2 className="font-display text-xl font-medium tracking-tight text-foreground">
          Site Media
        </h2>
      </div>
      {displayItems.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 bg-muted/20 rounded-xl border border-border/20">
          <Camera className="h-10 w-10 mb-2 opacity-20 text-muted-foreground" />
          <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground/40 italic">
            No Site Media Available
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {displayItems.map((item, idx) => (
            <MediaCard
              key={idx}
              item={item}
              onSelect={() => onMediaSelect(item)}
              isBroken={failedMediaIds.has(item.id)}
              onLoadError={() => handleImageError(item.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
